<template>
  <div class="callback-container">正在登录中...</div>
</template>

<script>
  import store from '@/store'
  import { isWeixin } from '@/utils'
  import storage from '@/utils/storage'
  import { Toast } from 'vant'
  export default {
    name: 'Callback',
    data() {
      return {
        loading: null,
        redirect: '/',
        tenant: { TenantName: '' },
      }
    },
    created() {
      this.init()
    },
    methods: {
      init() {
        const query = this.$route.query
        const code = query.code || this.getUrlKey('code')
        if (code) {
          this.login(code)
        }
      },
      getUrlKey(name) {
        var reg = new RegExp('(^|&)' + name + '=([^&]*)(&|$)')
        var rrr = decodeURIComponent(window.location.search)
        var r = rrr.substr(1).match(reg)
        if (r != null) return unescape(r[2])
        return null
      },
      async login(code) {
        let url = 'user/WechatAuthor'
        const params = {
          code,
          tenantId: await this.getTenant(),
          expires: 999,
          type: 0,
        }
        store
          .dispatch(url, params)
          .then(async (data) => {
            if (data.Code === 0) {
              await this.$router.replace(this.handleRoute())
              storage.remove('redirect')
            } else {
              this.$baseMessage(
                '用户名或密码错误！',
                'error',
                'vab-hey-message-error'
              )
            }
          })
          .catch((e) => {
            this.loading = false
            let msg = e.Message || '微信登录失败'
            switch (e.Code) {
              case 2000:
                msg = `贵公司服务暂未启用，请联系腾宇一号!`
                break
              case 2001:
                msg = `您还未加入${this.tenant.TenantName}，请联系管理员!`
                break
              case 7000:
                msg = `租户不存在，请联系腾宇一号!`
                break
              case 7002:
                msg = `贵公司服务已过期，请联系腾宇一号!`
                break
              case 1000:
                msg = `用户微信未注册`
                break
              default:
                break
            }

            Toast(msg, 'error')

            setTimeout(() => {
              this.$router.replace({ name: 'Login' })
            }, 1000)
          })
      },
      getTenant() {
        return new Promise((resolve, reject) => {
          // 出现异常不能阻塞流程
          const hostname = window.location.hostname
          let subdomain = hostname.split('.')[0]
          if (subdomain === 'localhost' || subdomain === '192') {
            subdomain = 'www'
          }
          store
            .dispatch('user/GetTenantByCode', {
              code: subdomain,
            })
            .then((data) => {
              this.tenant = data.Data
              const TenantId = data.Data.TenantId
              if (!TenantId) {
                this.$confirm(
                  `${this.tenant.TenantName}尚未启用，请联系腾宇一号`,
                  '温馨提示',
                  {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning',
                  }
                )
                  .then(() => {})
                  .catch(() => {})
                reject(data.Data)
              } else {
                resolve(data.Data.TenantId)
              }
            })
            .catch((e) => {
              reject(e)
              this.$confirm('您的Code可能不存，请联系腾宇一号', '温馨提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning',
              })
                .then(() => {})
                .catch(() => {})
            })
        })
      },
      handleRoute() {
        let redirect = storage.get('redirect') || '/'
        return redirect
      },
    },
  }
</script>
<style lang="scss" scoped>
  .callback-container {
    padding: 14px 20px;
  }
</style>
